// @generated by protoc-gen-es v2.7.0 with parameter "target=ts"
// @generated from file provider/v1/predefined_string_rules.proto (package provider.v1, edition 2023)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { StringRules } from "../../buf/validate/validate_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";

/**
 * Describes the file provider/v1/predefined_string_rules.proto.
 */
export const file_provider_v1_predefined_string_rules: GenFile = /*@__PURE__*/
  fileDesc("Cilwcm92aWRlci92MS9wcmVkZWZpbmVkX3N0cmluZ19ydWxlcy5wcm90bxILcHJvdmlkZXIudjE6hgEKCXZhbGlkX25waRIZLmJ1Zi52YWxpZGF0ZS5TdHJpbmdSdWxlcxjoByABKAhCTcJISgpICgl2YWxpZF9ucGkSHW5waSBtdXN0IGJlIGEgMTAtZGlnaXQgbnVtYmVyGhxtYXRjaGVzKHRoaXMsICJeWzAtOV17MTB9JCIpUgh2YWxpZE5waTqLAQoLdmFsaWRfc3RhdGUSGS5idWYudmFsaWRhdGUuU3RyaW5nUnVsZXMY6QcgASgIQk7CSEsKSQoLdmFsaWRfc3RhdGUSGnN0YXRlIG11c3QgYmUgMiBjaGFyYWN0ZXJzGh5tYXRjaGVzKHRoaXMsICJeW2EtekEtWl17Mn0kIilSCnZhbGlkU3RhdGU6jwEKDnZhbGlkX3ppcF9jb2RlEhkuYnVmLnZhbGlkYXRlLlN0cmluZ1J1bGVzGOoHIAEoCEJNwkhKCkgKDnZhbGlkX3ppcF9jb2RlEhl6aXBfY29kZSBtdXN0IGJlIDUgZGlnaXRzGhttYXRjaGVzKHRoaXMsICJeWzAtOV17NX0kIilSDHZhbGlkWmlwQ29kZTqRAQoKdmFsaWRfbmFtZRIZLmJ1Zi52YWxpZGF0ZS5TdHJpbmdSdWxlcxjrByABKAhCVsJIUwpRCgp2YWxpZF9uYW1lEh1uYW1lIG11c3QgYmUgMS0xMDAgY2hhcmFjdGVycxokdGhpcy5zaXplKCkgPiAwICYmIHRoaXMuc2l6ZSgpIDwgMTAxUgl2YWxpZE5hbWU6qQEKE3ZhbGlkX3RheG9ub215X2NvZGUSGS5idWYudmFsaWRhdGUuU3RyaW5nUnVsZXMY7AcgASgIQl3CSFoKWAoTdmFsaWRfdGF4b25vbXlfY29kZRIcbmFtZSBtdXN0IGJlIDEtMTAgY2hhcmFjdGVycxojdGhpcy5zaXplKCkgPiAwICYmIHRoaXMuc2l6ZSgpIDwgMTFSEXZhbGlkVGF4b25vbXlDb2RlQkZaRGdpdGh1Yi5jbXMuZ292L0NNUy1NQ1QvcHJvdmlkZXItbmV0d29yay1hcGkvZ2VuL3Byb3ZpZGVyL3YxO3Byb3ZpZGVyYghlZGl0aW9uc3DoBw", [file_buf_validate_validate]);

/**
 * The npi must be a 10-digit number.
 *
 * @generated from extension: bool valid_npi = 1000;
 */
export const valid_npi: GenExtension<StringRules, boolean> = /*@__PURE__*/
  extDesc(file_provider_v1_predefined_string_rules, 0);

/**
 * The state must be a 2-character state code.
 *
 * @generated from extension: bool valid_state = 1001;
 */
export const valid_state: GenExtension<StringRules, boolean> = /*@__PURE__*/
  extDesc(file_provider_v1_predefined_string_rules, 1);

/**
 * The ZIP code must be 5 digits.
 *
 * @generated from extension: bool valid_zip_code = 1002;
 */
export const valid_zip_code: GenExtension<StringRules, boolean> = /*@__PURE__*/
  extDesc(file_provider_v1_predefined_string_rules, 2);

/**
 * The name must be between 1 and 100 characters long.
 *
 * @generated from extension: bool valid_name = 1003;
 */
export const valid_name: GenExtension<StringRules, boolean> = /*@__PURE__*/
  extDesc(file_provider_v1_predefined_string_rules, 3);

/**
 * The taxonomy code must be between 1 and 10 characters long.
 *
 * @generated from extension: bool valid_taxonomy_code = 1004;
 */
export const valid_taxonomy_code: GenExtension<StringRules, boolean> = /*@__PURE__*/
  extDesc(file_provider_v1_predefined_string_rules, 4);

